import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DerogacionesValidarService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient,
  ) {
    this.http = http;
  }
  /**
   * @description Recuperar derogaciones
   * @params code
   */
  getCheckDerogationCode(code: string): Observable<ArrayBuffer> {
    const httpOpt: NgxHttpClientExtraOptions | any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    const obj: any = { codDerogacion: code };
    httpOpt.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.derogacionesValidar.name,
      httpOpt
    );

  }
}
